export type ParticipantListStatus = "HAS_CHANGES" | "READY" | "SENT";

export const participantListStatusLabels: Record<ParticipantListStatus, string> = {
  HAS_CHANGES: "Zmiany na liście",
  READY: "Lista gotowa dla dostawcy",
  SENT: "Lista wysłana do dostawcy",
} as const;

export const participantListStatusColors: Record<ParticipantListStatus, string> = {
  HAS_CHANGES: "#ff9933",
  READY: "#4caf50",
  SENT: "#6fa8dc",
};
